export const BRAND_SEARCH_ALIASES: Readonly<Record<string, readonly string[]>> = {
  "head shoulders": ["H&S", "хед энд шолдерс"],
  president: ["президент", "презідент"],
  nivea: ["нивея", "нівея"],
  ariel: ["ариэль", "аріель"],
  "casuta mea": ["касуца мя"],
  borjomi: ["боржоми", "borjomy"],
  frosch: ["фрош"],
  olympus: ["олимпус"],
  nesquik: ["несквик"],
  purcari: ["пуркарь", "пуркари", "porcari"],
  "jack daniels": ["джек дениэлс", "джек дэниэлс", "jackdaniels", "jak danels"],
};
